import Vue from 'vue';
import Vuex, { ActionContext, ActionTree } from 'vuex';
import { auth } from '../modules/auth/store/auth';
import { home } from '../modules/home-page/store/home';
import { collaborators } from '@/modules/collaborators/store/collaborators';
import { CHAIN_ID, CHAIN_ID_NUMBER } from '@/abi/token';
import Web3 from 'web3';

export interface IRootState {
    language: string;
    showLoadingIndicator: boolean;
    commonMessage: string;

    dialogWallet: boolean;

    chainId: string;
    chainIdNumber: number;
    web3: Web3 | null;
    provider: any;

    walletConnected: {
        walletAddress: string;
        connectedWallet: boolean | null,
        wallet: null
        chainId: null
    };
}

// set root state, action & mutation

const rootState = {
    language: 'en',
    showLoadingIndicator: false,
    commonMessage: '',
    dialogWallet: false,

    // web3
    chainId: CHAIN_ID,
    chainIdNumber: CHAIN_ID_NUMBER,
    web3: null,
    provider: null,
    walletConnected: localStorage.getItem('walletConnected') !== null ?
        // @ts-ignore
        JSON.parse(localStorage.getItem('walletConnected')) :
        {
            walletAddress: '',
            connectedWallet: null,
            wallet: null,
            chainId: null,
        },
};
const rootActions: ActionTree<IRootState, IRootState> = {
    setLanguage(context: ActionContext<IRootState, IRootState>, language: string) {
        context.commit('SET_LANGUAGE', language);
    },
    setLoadingIndicator(
        context: ActionContext<IRootState, IRootState>,
        showLoadingIndicator: boolean,
    ) {
        context.commit('SET_SHOW_LOADING_INDICATOR', showLoadingIndicator);
    },
    async setCommonMessage(
        context: ActionContext<IRootState, IRootState>,
        message: string,
    ) {
        context.commit('SET_COMMON_MESSAGE', message);
    },
};
const rootMutations = {
    SET_LANGUAGE(state: IRootState, language: string) {
        state.language = language;
    },
    SET_SHOW_LOADING_INDICATOR(state: IRootState, showLoadingIndicator: boolean) {
        state.showLoadingIndicator = showLoadingIndicator;
    },
    SET_COMMON_MESSAGE(state: IRootState, commonMessage: string) {
        state.commonMessage = commonMessage;
    },
    SET_SHOW_DIALOG_WALLET(state: IRootState, dialogWallet: boolean) {
        state.dialogWallet = dialogWallet;
    },

    // web3
    SET_CHAIN_ID(state: IRootState, chainId: string) {
        state.chainId = chainId;
    },

    SET_CHAIN_ID_NUMBER(state: IRootState, chainIdNumber: number) {
        state.chainIdNumber = chainIdNumber;
    },
    SET_WEB3(state: IRootState, web3: Web3 | null) {
        state.web3 = web3;
    },
    SET_PROVIDER(state: IRootState, provider: any) {
        state.provider = provider;
    },
    SET_WALLET_CONNECTED(state: IRootState, walletConnected: {
        walletAddress: string;
        connectedWallet: boolean | null,
        wallet: null,
        chainId: null
    }) {
        state.walletConnected = walletConnected;
    },
};
Vue.use(Vuex);

export default new Vuex.Store<IRootState>({
    modules: {
        auth,
        home,
        collaborators,
    },
    state: rootState,
    mutations: rootMutations,
    actions: rootActions,
});
